import React, { Component } from 'react'; 
import {InputGroup, FormControl, Table, Pagination, Spinner} from 'react-bootstrap';
import '../../Resources/css/clientmanagement.css';
import ClientManagement from './ClientManagement';
import ViewClientDetails from './ViewClientDetails';
import ShowModalPopUp from '../ShowModalPopUp';
import { connect } from 'react-redux';
import _ from 'lodash';
import {ClientManagementEdit, InventoryClientAction, FrequencyMaster, closeModalPopUp, ReportsMaster} from '../Inventory/InventoryAction.js' ;

function searchingFor(term){
	return function(x){
		return _.includes(x.inventoryClientName.toLowerCase(), term.toLowerCase()) || !term;
	}
}

class ClientIndex extends Component {
	constructor(props){
		super(props)
		this.state={
			term:'',
			activePage: 1
		}


	}
  componentWillMount(){		
		this.props.clientAction()
		this.props.actionReports()
		this.props.frequencyAction()
	}
	
	handleChange = (e) => {
		this.setState({term:e.target.value})	
	}
	
	openModalEdit =(i) => {
		this.setState({['modalIsVisibleEdit'+i]: true, });
	}
	
	closeModalEdit=(i) =>{
		this.setState({['modalIsVisibleEdit'+i]: false, });
	}
	openModalView =(i) => {
		this.setState({['modalIsRead'+i]: true });
	}
	closeModalView =(i) => {
		this.setState({['modalIsRead'+i]: false });
	}
	handleSelectPagination = (eventKey) => {
    this.setState({
      activePage: eventKey,
    });
	}
	handleSelectPaginationPrev = () => {
		const {activePage} = this.state;
		this.setState({
      activePage: activePage-1,
    });
	}
	handleSelectPaginationNext = () => {
		const {activePage} = this.state;
		this.setState({
      activePage: activePage+1,
    });
	}	
	
	tableBody = (permission, startOffset, startCount, Per_Page) => {
		const{clients, reportlist, freqlist}= this.props;
		const{term} = this.state;
		let processObj=[]
		let Obj = _.map(clients.value.filter(searchingFor(term)), (val, i)=>{
			processObj=[]
			if(i >= startOffset & startCount < Per_Page){
				startCount++;
				return(
				<tr>				
				<td  className={(val.status === 'INACTIVE') ? 'disabled' : ''}>{_.map(val.clientRegions, (obj)=> { 
			 	return(<span>{obj.inventoryRegionName}<br/></span>)}) }</td>
				<td  style={{width:'20%'}} className={(val.status === 'INACTIVE') ? 'disabled wordWrap' : 'wordWrap'}>{_.map(val.clientRegions, (obj, index1)=> { 
					return _.map(obj.clientCenters , (x, index) => {
						processObj.push(...x.processes)
						processObj = _.uniqBy(processObj, 'inventoryProcessName')
					return(<span>{((index) ? ', ' : '') + x.inventoryCenterName}</span>) })					
					})
				}</td>
				<td className={(val.status === 'INACTIVE') ? 'disabled' : ''}>{val.inventoryClientName}</td>		
				<td style={{width:'20%'}} className={(val.status === 'INACTIVE') ? 'disabled wordWrap' : 'wordWrap'}>
				{_.map(processObj, (obj)=> { 
					return (obj.inventoryProcessName)
					 }).join(',') 
				}</td>					
				{(permission === true) ?
				<td className='cant_be_disabled'>
				<i className='fas fa-pen' onClick={()=>this.openModalEdit(i)} />
				{this.state['modalIsVisibleEdit'+i] ?  
				<ClientManagement  closeModal={()=>this.closeModalEdit(i)} edit={val} function
				action={this.props} editOption={true}  reportlist={reportlist} 
				freqlist={freqlist}/> : null}
				</td> : null} 
				<td><i class='fas fa-eye' onClick={()=>this.openModalView(i)}/>
					{this.state['modalIsRead'+i] ?
					<ViewClientDetails closeModal={()=>this.closeModalView(i)}  data={val}/> : null}
				</td>
					</tr>						
					)
				} 
			})

				return Obj;
		}
	
	render(){
		const{clients, loginAction}= this.props;
		let permission = false
		const{term, activePage} = this.state;	
		let style= true
		if(typeof this.props.size !== 'undefined'){
			style = this.props.size
		}
		let items=[]
		const Per_Page=50;
		let totalPages =  1;
		if(!_.isEmpty(clients)){
			totalPages = Math.ceil(clients.value.length/Per_Page)
		}
		const startOffset = (activePage-1) * Per_Page;
		let startCount = 0;
		for (let number = 1; number <= totalPages; number++) {
			items.push(
				<Pagination.Item key={number} active={number === activePage} onClick={()=>this.handleSelectPagination(number)}>
					{number}
				</Pagination.Item>				
			);
		}	
		if(!_.isEmpty(loginAction)){
			let moduleAccess = _.find(loginAction.modulescreens, {"moduleUId": "CLIENT_MANAGEMENT"})
			let accessPermission= moduleAccess.screens[0].accessPermission
			permission  = _.includes(accessPermission, 'WRITE')
		}
		return(
    <div>
     
      <div className={(style) ? 'user' : "userSmall"}>				
			{this.props.isPending ? <p className='spinner'><Spinner animation="grow" role="status" size='lg'/>
				Loading...</p> : null}
			{(this.props.showerror === true) ?
			(<ShowModalPopUp message={this.props.errmessage} 
			falseShowModalPopUp={this.props.closeModalPopUp}/>) : null}   
			<div className="firstDiv">
					<span className='alignRight'>
					<InputGroup>
					<InputGroup.Prepend>
					<InputGroup.Text id="basic-addon1"><i class="fas fa-search"></i></InputGroup.Text>
					</InputGroup.Prepend>
					<FormControl
					placeholder="Search"
					aria-label="Search"
					aria-describedby="basic-addon1"
					onChange={(e) => this.handleChange(e)}
					value={term}
					/>
					</InputGroup>
					</span>	
					</div>			
				{(!_.isEmpty(clients) && !_.isEmpty(clients.value) )?
				<div className='clientList'> 
				<Table responsive>
					<thead>
							<tr>											
								<th>REGION</th>
								<th>CENTER</th>
								<th>CLIENT</th>	
								<th>PROCESS</th>	
								{(permission === true) ? <th>EDIT</th> : null}
								<th>VIEW</th>
							</tr>
					</thead>
          <tbody>
					{this.tableBody(permission, startOffset, startCount, Per_Page)}
          </tbody>
          </Table>
					<Pagination>
					<Pagination.First  disabled={activePage === 1} onClick={()=>this.handleSelectPagination(1)} />
					<Pagination.Prev   disabled={activePage === 1} onClick={this.handleSelectPaginationPrev} />
							{items}
					<Pagination.Next disabled={activePage === totalPages} onClick={this.handleSelectPaginationNext}/>
					<Pagination.Last disabled={activePage === totalPages} onClick={()=>this.handleSelectPagination(totalPages)}/>			
				</Pagination>
					</div>
          : null }
      </div>
      
    </div>
    );
  }
}

function mapStateToProps(state){
  return{
	 clients: state.InventoryReducer.clients,	 
   size: state.UserReducer.large,
	 isPending: state.InventoryReducer.isPending,
	 reportlist:state.InventoryReducer.reportList,
	 freqlist:state.InventoryReducer.freqList,
	 showerror:  state.InventoryReducer.showerror, 
	 errmessage:  state.InventoryReducer.errmessage,	 
	 loginAction: state.LoginReducer.loginAction,
  }  
}

const mapDispatchToProps = (dispatch) => ({
	clientAction: () => dispatch(InventoryClientAction()),
	editClient: (a) => dispatch(ClientManagementEdit(a)),
	frequencyAction: () =>dispatch(FrequencyMaster()),	
	closeModalPopUp:  (a) =>dispatch(closeModalPopUp(a)), 
  actionReports:  (a) =>dispatch(ReportsMaster(a)), 
})


export default connect(mapStateToProps, mapDispatchToProps)(ClientIndex);